import React from "react";

const HowItWorks = ({ steps }) => {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-5xl mx-auto px-6">
                <h2 className="text-3xl font-bold text-brand-blue mb-12 text-center">Cómo funciona</h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-10">
                    {steps.map((step, i) => (
                        <div key={i} className="text-center px-4">
                            <div className="w-14 h-14 bg-brand-blue text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                                {i + 1}
                            </div>
                            <h3 className="font-semibold text-gray-900 mb-2">{step.title}</h3>
                            <p className="text-gray-500 text-sm">{step.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
